import { render } from "./NoNavBar.vue?vue&type=template&id=16164bac"
import script from "./NoNavBar.vue?vue&type=script&lang=js"
export * from "./NoNavBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__